import { type ReactNode } from 'react'
import { Head } from '@inertiajs/react'
import AdminLayout from '@/components/AdminLayout'
import EventServiceForm from '@/components/EventServiceForm'
import type { EventService } from '@/types'

type Props = {
  service: EventService
  service_types: string[]
  price_ranges: string[]
  statuses: string[]
  additional_service_options: string[]
}

export default function AdminEventServicesEdit({ service, service_types, price_ranges, statuses, additional_service_options }: Props) {
  return (
    <>
      <Head title={`Admin - Edit ${service.name}`} />
      <EventServiceForm service={service} serviceTypes={service_types} priceRanges={price_ranges} statuses={statuses} additionalServiceOptions={additional_service_options} />
    </>
  )
}

AdminEventServicesEdit.layout = (page: ReactNode) => <AdminLayout>{page}</AdminLayout>
